import React,{ useState, useEffect, useRef, useMemo } from 'react';
import MaterialTable from 'material-table';
import TableIcons from '../components/TableIcons';
import { tableOptions } from '../components/TableDefaults';
import {
  Grid,
  Typography,
  Button,
  Modal,
  TextField,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Box,
  Chip
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment';
// WalletCard replaced with modern inline gradient card
import AlertDialog from '../components/AlertDialog';
import AlertDialogTwoButton from '../components/AlertDialogTwoButton';
import styles from '../styles/landingPage.js';
import { useNavigate } from 'react-router-dom';
import {colors} from '../components/Theme/WebTheme';

const useStyles = makeStyles(theme => ({
  ...styles,
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 440,
    maxWidth: '95vw',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    padding: theme.spacing(3),
    borderRadius: 16,
  },
  inputRtl: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    }
  },
  balanceCard: {
    background: `linear-gradient(135deg, ${colors.PRIMARY} 0%, ${colors.ACCENT_SOLID} 100%)`,
    borderRadius: 16,
    padding: 24,
    color: '#FFFFFF',
    marginBottom: 24,
    boxShadow: '0 4px 12px rgba(37,99,235,0.3)',
  },
  actionBtn: {
    borderRadius: 12,
    padding: '12px 24px',
    fontWeight: 600,
    textTransform: 'none',
  },
}));

const icons = {
  'paypal':require('../assets/payment-icons/paypal-logo.png').default,
  'braintree':require('../assets/payment-icons/braintree-logo.png').default,
  'stripe':require('../assets/payment-icons/stripe-logo.png').default,
  'paytm':require('../assets/payment-icons/paytm-logo.png').default,
  'payulatam':require('../assets/payment-icons/payulatam-logo.png').default,
  'flutterwave':require('../assets/payment-icons/flutterwave-logo.png').default,
  'paystack':require('../assets/payment-icons/paystack-logo.png').default,
  'securepay':require('../assets/payment-icons/securepay-logo.png').default,
  'payfast':require('../assets/payment-icons/payfast-logo.png').default,
  'liqpay':require('../assets/payment-icons/liqpay-logo.png').default,
  'culqi':require('../assets/payment-icons/culqi-logo.png').default,
  'mercadopago':require('../assets/payment-icons/mercadopago-logo.png').default,
  'squareup':require('../assets/payment-icons/squareup-logo.png').default,
  'wipay':require('../assets/payment-icons/wipay-logo.png').default,
  'test':require('../assets/payment-icons/test-logo.png').default,
  'razorpay':require('../assets/payment-icons/razorpay-logo.png').default,
}


const UserWallet = (props) => {
  const {
    updateWalletBalance,
  } = api;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  const { t,i18n } = useTranslation();
  const isRTL = i18n.dir();
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const providers = useSelector(state => state.paymentmethods.providers);
  const [profile,setProfile] = useState();
  const [data,setData] = useState([]);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const [commonAlertTwoButton, setCommonAlertTwoButton] = useState({ open: false, msg: '' });
  const rootRef = useRef(null);
  const [amount,setAmount] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalInfo,setModalInfo] = useState({
    mOpen: false,
    mType: null
  });
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const [filter, setFilter] = useState('all');
  const columns =  [
      { title: t('requestDate'), field: 'date', render: rowData => rowData.date ? moment(rowData.date).format('lll') : null,},
      { title: t('amount'), field: 'amount',editable: 'never',},
      { title: t('transaction_id'), field: 'transaction_id', render: rowData => rowData.transaction_id ? rowData.transaction_id : rowData.txRef, },
      { title: t('type'), field: 'type', render: rowData => t(rowData.type),}
  ];

  useEffect(()=>{
    if(providers){
      setSelectedProvider(providers[0]);
    }
  },[providers]);

  useEffect(()=>{
    if(auth.profile){
        setProfile(auth.profile);
        let wdata = auth.walletHistory;
        var wallHis = [];
        for(let key in wdata){
            wdata[key].walletKey = key
            if(wdata[key].type.includes("Credit") || wdata[key].type.includes("credit")){
              wdata[key].type = 'credited'
            }else if(wdata[key].type.includes("Withdraw") || wdata[key].type.includes("withdraw")){
              wdata[key].type = 'withdraw'
            }else{
              wdata[key].type = 'debited'
            }
            wallHis.push(wdata[key])
        }
        if(wallHis.length>0){
          setData(wallHis.reverse());
        }else{
          setData([]);
        }

    } else{
        setProfile(null);
    }
  },[auth.profile,auth.walletHistory]);

  const doRecharge = (e) => {
    e.preventDefault();
    if(!(profile.mobile && profile.mobile.length > 6 && profile.email && profile.firstName)){
      setCommonAlertTwoButton({ open: true, msg: t('profile_incomplete')})
     } else{
      if (providers) {
        setModalInfo({
          mOpen: true,
          mType: 'add'
        });
      } else {
        setCommonAlert({ open: true, msg: t('provider_not_found')})
      }
    }
  }

  const doWithdraw = (e) => {
    e.preventDefault();
    if(!(profile.mobile && profile.mobile.length > 6 && profile.email && profile.firstName)){
      setCommonAlertTwoButton({ open: true, msg: t('profile_incomplete')})
    }else{
        if (parseFloat(profile.walletBalance)>0) {
          setModalInfo({
            mOpen: true,
            mType: 'withdraw'
          });
        } else {
          setCommonAlert({ open: true, msg: t('wallet_bal_low')})
        }
    }
  }

  const gotoOperation = () => {
    navigate('/profile');
    setCommonAlert({ open: false, msg: '' })
  };

  const cancelOperation = () => {
    setAmount(0);
    setModalInfo({
      mOpen: false,
      mType: null
    });
    setCommonAlert({ open: false, msg: '' })
  };

  const cancelOperationTowButton = () => {
    setAmount(0);
    setModalInfo({
      mOpen: false,
      mType: null
    });
    setCommonAlertTwoButton({ open: false, msg: '' })
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if(amount <= 0){
      setCommonAlert({ open: true, msg: t('valid_amount')});
    } else {
       if(modalInfo.mType === 'add'){
        setModalInfo({
          ...modalInfo,
          mOpen: false
        });
        setPaymentModalStatus(true);
       }else{
        if( parseFloat(profile.walletBalance) < amount){
          setCommonAlert({ open: true, msg: t('valid_amount')});
        }else{
          let walletBal = parseFloat(profile.walletBalance) - amount;
          let tDate = new Date();
          let details = {
            type: 'Withdraw',
            amount: amount,
            date: tDate.getTime(),
            txRef: tDate.getTime().toString(),
            transaction_id: tDate.getTime().toString()
          }
          dispatch(updateWalletBalance(walletBal,details));
          cancelOperation();
         }
        }
    }
  }

  const createOrderId = () =>{
    const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const reference = [...Array(4)].map(_ => c[~~(Math.random()*c.length)]).join('');
    return "wallet-" + auth.profile.uid + "-" + reference
  }

  const handlePaymentModalClose = (e) => {
    setTimeout(()=>{
      setPaymentModalStatus(false);
    },1500);
  }

  
  const history = useMemo(()=>{
    if(!auth.walletHistory) return [];
    const arr = Object.values(auth.walletHistory);
    return arr;
  },[auth.walletHistory]);

  const totals = useMemo(()=>{
    let credit=0, debit=0, withdraw=0;
    history.forEach(h=>{
      const t = (h.type||'').toLowerCase();
      if(t.includes('credit')) credit += Number(h.amount||0);
      else if(t.includes('withdraw')) withdraw += Number(h.amount||0);
      else debit += Number(h.amount||0);
    });
    return { credit, debit, withdraw };
  },[history]);

  const filteredData = useMemo(() => {
    if (!Array.isArray(data)) return [];
    if (filter === 'all') return data;
    if (filter === 'credit') return data.filter(d => (d.type||'').toLowerCase().includes('credit'));
    if (filter === 'debit') return data.filter(d => (d.type||'').toLowerCase().includes('debit'));
    if (filter === 'withdraw') return data.filter(d => (d.type||'').toLowerCase().includes('withdraw'));
    return data;
  }, [data, filter]);

  return (
    <div>
      <div style={{borderRadius: 16, padding: 16}}>
        <Typography variant="h4" style={{margin:"20px 20px 10px 15px", textAlign:isRTL==='rtl'?'right':'left', fontWeight: 700, color: colors.DARK}}>{t('my_wallet_tile')}</Typography>

        {/* Balance Card with Gradient */}
        <Box className={classes.balanceCard} sx={{ mb: 3 }}>
          <Typography variant="body2" sx={{ opacity: 0.9, mb: 0.5 }}>{t('balance')}</Typography>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            {settings.swipe_symbol === false
              ? settings.symbol + ' ' + (profile && profile.hasOwnProperty('walletBalance') ? profile.walletBalance : '0.00')
              : (profile && profile.hasOwnProperty('walletBalance') ? profile.walletBalance : '0.00') + ' ' + settings.symbol
            }
          </Typography>
        </Box>

        {/* Stats Cards */}
        <Box sx={{ display:'flex', gap:2, flexWrap:'wrap', mb: 3 }}>
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: '#F0FDF4', border: '1px solid #BBF7D0', flex: 1, minWidth: 120 }}>
            <Typography variant="caption" sx={{ color: '#166534', fontWeight: 600 }}>{t('total_credited') || 'Total Credited'}</Typography>
            <Typography variant="h6" sx={{ color: '#15803D', fontWeight: 700 }}>{settings?.symbol}{totals.credit.toFixed(2)}</Typography>
          </Box>
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: '#FEF2F2', border: '1px solid #FECACA', flex: 1, minWidth: 120 }}>
            <Typography variant="caption" sx={{ color: '#991B1B', fontWeight: 600 }}>{t('total_debited') || 'Total Debited'}</Typography>
            <Typography variant="h6" sx={{ color: '#DC2626', fontWeight: 700 }}>{settings?.symbol}{totals.debit.toFixed(2)}</Typography>
          </Box>
          <Box sx={{ p: 2, borderRadius: 3, bgcolor: '#FFF7ED', border: '1px solid #FED7AA', flex: 1, minWidth: 120 }}>
            <Typography variant="caption" sx={{ color: '#9A3412', fontWeight: 600 }}>{t('total_withdrawn') || 'Total Withdrawn'}</Typography>
            <Typography variant="h6" sx={{ color: '#EA580C', fontWeight: 700 }}>{settings?.symbol}{totals.withdraw.toFixed(2)}</Typography>
          </Box>
        </Box>

        {/* Action Buttons */}
        <Grid container direction="row" spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={settings && settings.RiderWithDraw ? 6 : 12}>
                <Button
                  onClick={doRecharge}
                  variant="contained"
                  className={classes.actionBtn}
                  style={{width:'100%', backgroundColor: colors.PRIMARY, color: '#FFFFFF', boxShadow: '0 4px 12px rgba(37,99,235,0.3)'}}
                  size='large'
                >
                  {t('add_to_wallet')}
                </Button>
            </Grid>
            {settings && settings.RiderWithDraw ?
              <Grid item xs={12} sm={6}>
                  <Button
                    onClick={doWithdraw}
                    variant="outlined"
                    className={classes.actionBtn}
                    style={{width:'100%', borderColor: colors.PRIMARY, color: colors.PRIMARY, backgroundColor: '#FFFFFF'}}
                    size='large'
                  >
                    {t('withdraw')}
                  </Button>
              </Grid>
            :null}
        </Grid>

        {/* Filter Chips */}
        <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          <Chip
            label={t('all') || 'All'}
            onClick={()=>setFilter('all')}
            sx={{
              bgcolor: filter==='all' ? '#111827' : '#F7F7F7',
              color: filter==='all' ? '#FFFFFF' : '#374151',
              fontWeight: 500,
              fontSize: 13,
              height: 36,
              borderRadius: 50,
              px: 1,
              cursor: 'pointer',
              '&:hover': { bgcolor: filter==='all' ? '#000000' : '#EFEFEF' },
            }}
          />
          <Chip
            label={t('credited') || 'Credited'}
            onClick={()=>setFilter('credit')}
            sx={{
              bgcolor: filter==='credit' ? '#111827' : '#F7F7F7',
              color: filter==='credit' ? '#FFFFFF' : '#374151',
              fontWeight: 500,
              fontSize: 13,
              height: 36,
              borderRadius: 50,
              px: 1,
              cursor: 'pointer',
              '&:hover': { bgcolor: filter==='credit' ? '#000000' : '#EFEFEF' },
            }}
          />
          <Chip
            label={t('debited') || 'Debited'}
            onClick={()=>setFilter('debit')}
            sx={{
              bgcolor: filter==='debit' ? '#111827' : '#F7F7F7',
              color: filter==='debit' ? '#FFFFFF' : '#374151',
              fontWeight: 500,
              fontSize: 13,
              height: 36,
              borderRadius: 50,
              px: 1,
              cursor: 'pointer',
              '&:hover': { bgcolor: filter==='debit' ? '#000000' : '#EFEFEF' },
            }}
          />
          <Chip
            label={t('withdraw') || 'Withdraw'}
            onClick={()=>setFilter('withdraw')}
            sx={{
              bgcolor: filter==='withdraw' ? '#111827' : '#F7F7F7',
              color: filter==='withdraw' ? '#FFFFFF' : '#374151',
              fontWeight: 500,
              fontSize: 13,
              height: 36,
              borderRadius: 50,
              px: 1,
              cursor: 'pointer',
              '&:hover': { bgcolor: filter==='withdraw' ? '#000000' : '#EFEFEF' },
            }}
          />
          <Typography sx={{ ml: 'auto', fontSize: 13, color: '#6B7280', alignSelf: 'center' }}>
            {filteredData.length} {t('transactions') || 'transactions'}
          </Typography>
        </Box>
      </div>

      <MaterialTable
        icons={TableIcons}
        title={null}
        columns={columns}
        style={{
          direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
          borderRadius: 12,
          boxShadow: 'none',
          border: '1px solid #E5E7EB',
          overflow: 'hidden',
        }}
        data={filteredData}
        onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
        options={{
          ...tableOptions,
          search: false,
          toolbar: false,
          showTitle: false,
          exportButton: true,
          rowStyle: rowData => ({
            backgroundColor: (selectedRow === rowData.tableData.id) ? '#F3F4F6' : '#fff'
          }),
        }}
        localization={{
          toolbar: {
            searchPlaceholder: (t('search')),
            exportTitle: (t('export')),
          },
          pagination: {
            labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
            firstTooltip: (t('first_page_tooltip')),
            previousTooltip: (t('previous_page_tooltip')),
            nextTooltip: (t('next_page_tooltip')),
            lastTooltip: (t('last_page_tooltip'))
          },
        }}
      />

      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} spacing={2} className={classes.paper}>
        {providers && selectedProvider && modalInfo.mType === 'add'  && amount>0?
          <form action={selectedProvider.link} method="POST">
            <input type='hidden' name='order_id' value={createOrderId()}/>
            <input type='hidden' name='amount' value={amount}/>
            <input type='hidden' name='currency' value={settings.code}/>
            <input type='hidden' name='product_name' value={t('add_money')}/>
            <input type='hidden' name='first_name' value={profile.firstName}/>
            <input type='hidden' name='last_name' value={profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={auth.profile.uid}/>
            <input type='hidden' name='mobile_no' value={profile.mobile}/>
            <input type='hidden' name='email' value={profile.email}/>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
              <FormControl fullWidth>
              <FormLabel component="legend">{t('payment')}</FormLabel>
              <Select
               fullWidth
                  id="selectedProviderIndex"
                  name= "selectedProviderIndex"
                  value={selectedProviderIndex}
                  label={t('payment')}
                  onChange={(e)=>{
                      setSelectedProviderIndex(parseInt(e.target.value));
                      setSelectedProvider(providers[parseInt(e.target.value)]);
                  }}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {providers.map((provider,index) =>
                     <MenuItem key={provider.name} value={index} style={{ width:'100%', justifyContent:'center', paddingLeft:10}}><img style={{height:24,margin:7}} src={icons[provider.name]} alt={provider.name}/> </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{display: 'flex', gap: 12, marginTop: 16}}>
            <Button onClick={handlePaymentModalClose} variant="outlined" style={{padding:'12px 24px', borderColor: colors.BORDER_BACKGROUND, color: colors.DARK, borderRadius: 12, fontWeight: 600, textTransform: 'none'}}>
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" type="submit" onClick={handlePaymentModalClose} style={{padding:'12px 24px', backgroundColor: colors.PRIMARY, color: '#FFFFFF', borderRadius: 12, fontWeight: 600, textTransform: 'none', boxShadow: '0 4px 12px rgba(37,99,235,0.3)'}}>
              {t('paynow_button')}
            </Button>
            </Grid>
          </form>
          :null}
        </Grid>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={modalInfo.mOpen}
        onClose={cancelOperation}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={1} className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
            <Typography component="h2" variant="h5" style={{marginTop:15, color:'#000'}}>
                {t('amount')}
            </Typography>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="amount"
                label={t('amount')}
                name="amount"
                autoComplete="amount"
                onChange={(e)=>{
                  try{
                    if(e.target.value === ""){
                      setAmount(0);
                    }else{
                      setAmount(parseFloat(e.target.value));
                    }
                  }catch(e){
                    setCommonAlert({ open: true, msg: t('no_details_error')});
                    setAmount(0);
                  }          
                }}
                value={amount.toString()}
                autoFocus
                className={isRTL==='rtl'?classes.inputRtl:null}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left', display: 'flex', gap: 12, marginTop: 16}}>
            <Button onClick={cancelOperation} variant="outlined" style={{padding:'12px 24px', borderColor: colors.BORDER_BACKGROUND, color: colors.DARK, borderRadius: 12, fontWeight: 600, textTransform: 'none'}}>
              {t('cancel')}
            </Button>
            <Button onClick={handleSubmit} variant="contained" style={{padding:'12px 24px', backgroundColor: colors.PRIMARY, color: '#FFFFFF', borderRadius: 12, fontWeight: 600, textTransform: 'none', boxShadow: '0 4px 12px rgba(37,99,235,0.3)'}}>
              {modalInfo.mType === 'add'? t('add_to_wallet'): t('withdraw')}
            </Button>
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={cancelOperation}>{commonAlert.msg}</AlertDialog>
      <AlertDialogTwoButton open={commonAlertTwoButton.open} onClose={cancelOperationTowButton} onGoto={gotoOperation}>{commonAlertTwoButton.msg}</AlertDialogTwoButton>
    </div>
  );
}

export default UserWallet;
